const NEWS_API_URL = "https://opc-s.onrender.com/api/news";

export const fetchAllArticles = async () => {
  const response = await fetch(NEWS_API_URL);

  if (!response.ok) {
    throw new Error(`News API failed: ${response.status}`);
  }

  const data = await response.json();

  return data.news || [];
};

export const fetchArticleBySlug = async (slug) => {
  const response = await fetch(
    `${NEWS_API_URL}/${encodeURIComponent(slug)}`
  );

  if (response.status === 404) {
    return null;
  }

  if (!response.ok) {
    throw new Error(`News article API failed: ${response.status}`);
  }

  return await response.json();
};
